import React from 'react'
import R from 'ramda'
import {Marker} from 'react-leaflet'
import {divIcon} from 'leaflet'
import {connect} from 'react-redux'

import {Popup} from 'react-leaflet'

import flipEstateCard from '../actions/flipEstateCard'
import EstatePopupCard from './EstatePopupCard'

import loadSummaries from '../actions/loadSummaries'
import showDirections from '../actions/showDirections'
import setMap from '../actions/setMap'

const estateIcon = (selected, matching) => {

    var markerSrc;
    if(!matching)
    {
      markerSrc = '/images/marker/marker-property-other.png';
    }
    else if(matching && selected)
    {
      markerSrc = '/images/marker/marker-property-inverted.png'
    }
    else
    {
      markerSrc = '/images/marker/marker-property.png';
    }

    return divIcon({
    iconSize:[57,61],
    iconAnchor: [29,57],
    html: `
        <img class="${selected ? 'rotate-on-y-for-ever' : ''}" 
             src="${markerSrc}"/>
    `
  });
}

import EstatePopup from './EstatePopup'
//TODO  an exception will be raised when the popup is removed 
//see https://github.com/PaulLeCam/react-leaflet/issues/169

class EstateMarker extends React.Component {
  shouldComponentUpdate(nextProps){
    return !R.equals(nextProps, this.props)
  }
  render(){
    const {estate,onToggle, matchSearch, selected, fullEstate, options} = this.props
    const offset = matchSearch ? 3000 : 2000
    const bonusOffset = selected ? 2000 : 0

    var partnerName = "";
    var proximityScore = -999;
    var pertinenceScore = -999;

    
    if(typeof fullEstate !== "undefined")
    {      
      //partnerName = R.prop('name', R.find(R.propEq('id', fullEstate.partner), options.partners));
      partnerName = fullEstate.pfname;

      
      if(typeof estate.proximityScore !== "undefined"){
        proximityScore = estate.proximityScore;
        pertinenceScore = estate.pertinenceScore;
      }
      
    
      return <Marker zIndexOffset={offset + bonusOffset}
                     position={estate.coordinates} 
                     icon={estateIcon(selected, matchSearch)}
                     onClick={_ => onToggle(estate.id)}>
                <Popup>
                  <EstatePopupCard id={fullEstate.id}
                                address={fullEstate.address}
                                price={fullEstate.price}
                                rooms={fullEstate.rooms}
                                partner={partnerName}
                                like={fullEstate.like}
                                providerUrl={fullEstate.providerUrl}
                                proximityScore={proximityScore}
                                photos={fullEstate.photos}
                                pertinenceScore={pertinenceScore}
                                /> 
                </Popup>
             </Marker>
    }
    else
    {
    
      return <Marker zIndexOffset={offset + bonusOffset}
                     position={estate.coordinates} 
                     icon={estateIcon(selected, matchSearch)}
                     onClick={_ => onToggle(estate.id)}
                     >
             </Marker>
    }
  }
}

EstateMarker.propTypes = {
  estate: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
    coordinates: React.PropTypes.shape({
      lat: React.PropTypes.number.isRequired,
      lng: React.PropTypes.number.isRequired
    }).isRequired,
  }).isRequired,
  onToggle: React.PropTypes.func.isRequired,
  matchSearch: React.PropTypes.bool.isRequired,
  fullEstate: React.PropTypes.object,
  options: React.PropTypes.object.isRequired,
}

const mapStateToProps = (state, ownProps) => ({
  selected: state.selectedEstateId == ownProps.estate.id,
  fullEstate: R.path(['estates', ownProps.estate.id, 'data'], state),
  options: state.options,
})

const mapDispatchToProps = (dispatch) => ({
  onToggle: (estateId) => {
    dispatch(showDirections(estateId))
  }  
})



export default connect(mapStateToProps, mapDispatchToProps)(EstateMarker)




/** WEBPACK FOOTER **
 ** ./app/components/EstateMarker.jsx
 **/